import type { ApolloError } from '@apollo/client';
import { metrics } from '@seek/metrics-js';
import { useEffect } from 'react';

import { useAnalytics } from 'src/modules/analytics/AnalyticsProvider';

import { useUpdateShareableProfileViews } from './data';

export const useShareableProfileViewLoaded = ({
  isLoading,
  isErrorOrInactive,
  isSelfView,
}: {
  isLoading: boolean;
  isErrorOrInactive: ApolloError | boolean;
  isSelfView: boolean;
}) => {
  const { shareableProfileViewLoaded } = useAnalytics();
  const { updateShareableProfileViews } = useUpdateShareableProfileViews();

  useEffect(() => {
    if (!isLoading && !isErrorOrInactive) {
      metrics.count('shareable_profile_render');
      shareableProfileViewLoaded({
        isSelfView,
      });
    }
  }, [isLoading, isErrorOrInactive, isSelfView, shareableProfileViewLoaded]);

  useEffect(() => {
    if (!isLoading && !isErrorOrInactive && !isSelfView) {
      updateShareableProfileViews();
    }
  }, [isLoading, isErrorOrInactive, isSelfView, updateShareableProfileViews]);
};
